/**
 * @constructor
 * @param {number} win
 * @param {number} bet
 * @param {Array} winCoefs
 * @returns {BigWinCounter}
 */
import {fps} from "../framework/src/engine/madnes/madnes_variables";

export function BigWinCounter(win, bet, winCoefs)
{
    this._bigWinValue = winCoefs[0] * bet;
    this._megaWinValue = winCoefs[1] * bet;
    this._superWinValue = winCoefs[2] * bet;

    this._onUpdate = function(v) {};
    this._onBigWin = function(v) {};
    this._onMegaWin = function(v) {};
    this._onSuperWin = function(v) {};

    this._win = win;
    this._bet = bet;

    /** @type {number} */
    this._intervalTicker;

    /** @type {Function} */
    this.renderer = this._update.bind(this);

    /** @type {?Function} */
    this.resolver;

    this._types = {
        "bigwin": 0,
        "megawin": 1,
        "superwin": 2
    };
};

BigWinCounter.prototype.init = function() {
    this._currVal = 0;
    this._step = 0.1;

    this._bigWinFired = false;
    this._megaWinFired = false;
    this._superWinFired = false;

    this._speed = 2.7;
};

BigWinCounter.prototype._getType = function() {

    var type = this._types["bigwin"];
    if(this._currVal >= this._superWinValue) {
        type = this._types["superwin"];
    } else if (this._currVal >= this._megaWinValue) {
        type = this._types["megawin"];
    }

    return type;
};

BigWinCounter.prototype._update = function() {

    if(this._currVal >= this._win) {

        this._onUpdate(this._win);
        this._end();

        return;
    }

    var type = this._getType();

    switch (type) {
        case this._types["bigwin"]:

            this._currVal = (this._megaWinValue / this._speed) * this._step;

            if(!this._bigWinFired) {
                this._bigWinFired = true;
                this._onBigWin(this._currVal);
            }

            break;

        case this._types["megawin"]:

            this._currVal =
                (
                    (
                        ((this._superWinValue - this._megaWinValue)  / this._bet) * Math.exp((this._step - (2.0*this._speed)) * 0.1) +
                        ((this._step - this._speed) / this._speed - 1.0) * ((this._superWinValue - this._megaWinValue) / this._bet) * Math.exp(-this._speed * 0.1) +
                        (this._megaWinValue / this._bet)
                    ) * this._bet
                );


            if(!this._megaWinFired) {
                this._megaWinFired = true;
                this._onMegaWin(this._currVal);
            }

            break;

        case this._types["superwin"]:

            this._currVal =
                (
                    (
                        ((this._superWinValue - this._megaWinValue) / this._bet) * Math.exp((this._step -(2.0 * this._speed))) +
                        ((this._step - this._speed) / this._speed - 1.0) * ((this._superWinValue - this._megaWinValue) / this._bet) * Math.exp(this._speed) +
                        (this._megaWinValue / this._bet)
                    ) * this._bet
                );

            if(!this._superWinFired) {
                this._superWinFired = true;
                this._onSuperWin(this._currVal);
            }

            break;
    }

    this._onUpdate(this._currVal);
    this._step += 0.1;
};

BigWinCounter.prototype._end = function() {
    //madnes_rem_from_render(this.renderer);
    clearInterval(this._intervalTicker);
    this.resolver && this.resolver();
    this.resolver = null;
};

BigWinCounter.prototype.run = function() {
    var _this = this;

    this.init();

    return new Promise(function(res) {
        _this.resolver = res;

        _this._intervalTicker = setInterval(_this.renderer, 1000 / fps);

        //madnes_add_to_render(_this.renderer);

    });
};

BigWinCounter.prototype.onUpdate = function(func) {
    this._onUpdate = func;
};

BigWinCounter.prototype.onBigWin = function(func) {
    this._onBigWin = func;
};

BigWinCounter.prototype.onMegaWin = function(func) {
    this._onMegaWin = func;
};

BigWinCounter.prototype.onSuperWin = function(func) {
    this._onSuperWin = func;
};